import { useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueNCLCount } from '../../../store/emarsys/action';
import { Dispatch } from 'react';
import { PAGE_NAME_NEW_CAR_LIST } from '../../../constants/emarsys/new-car-list';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
/**
 *
 * @param firstRef
 * @param pageTitle
 * @param carCategory
 * @param carModel
 * @param sectionName hoverable menu | listing page | informasi mobil toyota | filter | urutkan
 * @returns
 */
const useImpressionNCL = (
  dispatch: Dispatch<any>,
  firstRef: React.RefObject<HTMLElement>,
  pageTitle: string = '',
  carCategory: string = '',
  carModel: string = '',
  sectionName: string = '',
  breadcrumbItems?: IBreadcrumbs[]
) => {
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isNCLActive = getFlagValue(FLAG_ENUM.EMARSYS_NEW_CAR_PURCHASE_PLP);
      if (isAuth && isFlagActive && isNCLActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: PAGE_NAME_NEW_CAR_LIST.MOBIL_BARU_LISTING_PAGE,
          page_title: pageTitle,
          page_url: window.location.href,
          section_name: sectionName,
        };

        if (breadcrumbItems?.[1]?.name) {
          valuePageView.menu_cat_lvl1 = breadcrumbItems?.[1]?.name?.toLowerCase();
        }

        if (breadcrumbItems?.[2]?.name && carCategory) {
          valuePageView.menu_cat_lvl2 = carCategory.toLowerCase();
        }

        if (carCategory) {
          valuePageView.car_category = carCategory.toLowerCase();
        }

        if (carModel) {
          valuePageView.car_model = carModel;
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueNCLCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px -88px 0px' : '-106px 0px -130px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 88 : 130
  );

  return null;
};

export default useImpressionNCL;
